exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "a.button {\n    -webkit-appearance: button;\n    -moz-appearance: button;\n    appearance: button;\n\n    text-decoration: none;\n    color: initial;\n    padding: 5px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/map/button.css
// module id = 293
// module chunks = 0